import { ControlOutlined } from '@ant-design/icons';
import React, {
  type ForwardRefExoticComponent,
  type RefAttributes,
} from 'react';

import styles from '@client/components/components.module.less';

import type { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon';

type TPageTitleProps = {
  name: string;
  Icon?: ForwardRefExoticComponent<
    Omit<AntdIconProps, 'ref'> & RefAttributes<HTMLSpanElement>
  >;
};

export const PageTitle = ({
  name,
  Icon = ControlOutlined,
}: TPageTitleProps): React.ReactNode => (
  <div className={styles.pageTitle}>
    <Icon />
    {name}
  </div>
);
